﻿export function initTiltCards(selector = ".credit-card", options = {}) {
    if (window.matchMedia("(hover: none)").matches) return;

    const cards = document.querySelectorAll(selector);
    if (!cards.length) return;

    const {
        maxRotateX = 4,
        maxRotateY = 5,
        perspective = 1200,
        baseRotate = 0
    } = options;

    cards.forEach((card) => {
        let rafId = null;

        function handleMove(e) {
            const rect = card.getBoundingClientRect();

            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            const centerX = rect.width / 2;
            const centerY = rect.height / 2;

            const percentX = (x - centerX) / centerX;
            const percentY = (y - centerY) / centerY;

            const rotateY = percentX * -maxRotateY;
            const rotateX = percentY * maxRotateX;

            cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                card.style.transform =
                    `perspective(${perspective}px) rotate(${baseRotate}deg) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateZ(0)`;
            });
        }

        function resetCard() {
            cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                card.style.transform =
                    `perspective(${perspective}px) rotate(${baseRotate}deg) rotateX(0deg) rotateY(0deg) translateZ(0)`;
            });
        }

        card.addEventListener("mousemove", handleMove);
        card.addEventListener("mouseleave", resetCard);
        card.addEventListener("mouseenter", resetCard);
    });
}